import { takeLatest, select, call, put } from "redux-saga/effects";
import { Customers } from "@grandvisionhq/api-client";
import { statusSuccess } from "@grandvisionhq/state";
import { getAuth, getUserData } from "../../selectors.js";
import { isLoggedIn } from "../../state.js";
import { getToken } from "../../token-service.js";
import { FETCH_USER_DATA, UPDATE_USER_DATA, fetchUserDataSuccess, fetchUserDataFailed, updateUserDataSuccess, updateUserDataFailed } from "./actions.js";
function* fetchUserData() {
  const auth = yield select(getAuth);
  if (!isLoggedIn(auth)) {
    throw new Error(`Can't fetch user data when not logged in`);
  }
  try {
    const token = yield call(getToken);
    const response = yield call(
      Customers.details,
      auth.apiUrl,
      token,
      auth.userId
    );
    yield put(fetchUserDataSuccess(response.personalDetails));
  } catch (err) {
    yield put(fetchUserDataFailed(err));
  }
}
function* updateUserData(action) {
  const { formName, formData } = action.payload;
  const auth = yield select(getAuth);
  const userData = yield select(getUserData);
  if (!isLoggedIn(auth)) {
    throw new Error(`Can't fetch user data when not logged in`);
  }
  if (userData && statusSuccess(userData)) {
    const updatedUserData = {
      ...userData.result,
      [formName]: formData
    };
    try {
      const token = yield call(getToken);
      yield call(Customers.updateDetails, auth.apiUrl, token, auth.userId, {
        personalDetails: updatedUserData
      });
      yield put(
        updateUserDataSuccess({
          server: updatedUserData,
          formName
        })
      );
    } catch (err) {
      yield put(updateUserDataFailed({ error: err, formName }));
    }
  }
}
const userDataSagas = [
  takeLatest(FETCH_USER_DATA, fetchUserData),
  takeLatest(UPDATE_USER_DATA, updateUserData)
];
export {
  userDataSagas as default,
  fetchUserData,
  updateUserData
};
//# sourceMappingURL=sagas.js.map
